import {Style, Icon} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';
import FeatureFormat from 'ol/format/Feature.js';

export class WindTempLayer extends GeoJsonLayer {
    icon_cache = {};

    constructor( map, settings = {}){
        settings["name"] = 'windtemp';
        settings["api_endpt"] = "WindTempJSON.php";
        settings["dynamic_time"] = true;
        settings["dynamic_level"] = true;
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "level", this.map.level );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        return url.toString();
    }

    getIconSize(feature){
        return this.settings['scale']*80;
    }

    getIcon( feature ){
        let isSHem = function(){ return feature.getGeometry().getCoordinates()[1] < 0 };
        
        let params = "id="+this.property(feature, 'id')+"&cover=S&";
        if( isSHem() )
            params += "wdir=" + this.property(feature, 'wdir') + "&";
        else
            params += "wdir=" + this.property(feature, 'wdir') + "&";
        if( this.property(feature, 'temp') != undefined )
            params += "temp=" + this.property(feature, 'temp') + "&";
        params += "wspd="+this.property(feature, 'wspd');
        
        return this.icon_path+'/stationicon.php?'+params;
    }

    getPopupText( feature ){
        let text = this.popupTitle( "FB WIND", this.property(feature,'id') );
        text += this.popupData( "Wind", this.property(feature, 'wdir')+" at "+this.property(feature, 'wspd')+"kt" );
        text += this.popupData( "Temp", this.property(feature, 'temp') );
        if( this.property(feature, 'valid_time') ) 
            text += this.popupData( "Valid", this.property(feature, 'valid_time') );
        text += this.popupEnd();
        return text;
    }

    getStyle(feature, resolution ){
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[ feature.getId()] ){
            icon = this.icon_cache[feature.getId()];
        } else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }

        let style = new Style({
                "image": icon
                });
        return style;
    }

    updateLevel(){
        this.icon_cache = {};
        this.refresh();
    }
    
    updateTime(){
        this.icon_cache = {};
        this.refresh();
    }
}
